import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';
import { auth } from '../firebaseConfig'; // Importa la instancia 'auth'

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Para saber si aún estamos verificando el estado

  // --- Firebase Auth Functions --- 

  function signup(email, password) {
    // Firebase crea el usuario y automáticamente inicia sesión
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  // --- Auth State Listener ---

  useEffect(() => {
    // Firebase nos notificará aquí si el usuario inicia sesión, cierra sesión,
    // o si la página se recarga y ya había una sesión activa.
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false); // Terminamos de cargar el estado inicial
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []); // El array vacío asegura que esto se ejecute solo una vez al montar

  // --- Context Value ---

  const value = {
    currentUser,
    signup, 
    login, 
    logout
  };

  // No renderizar la app hasta que sepamos si hay un usuario o no
  // para evitar flashes de contenido protegido/público incorrecto.
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
